module.exports = "/images/vendor/flag-icon-css/flags/1x1/jo.svg?5130279865a7759012e11ea127f87f9d";